var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33331 8.16663L11.8591 14.8346C12.6304 15.3746 13.0161 15.6446 13.4356 15.7492C13.8062 15.8415 14.1938 15.8415 14.5643 15.7492C14.9839 15.6446 15.3695 15.3746 16.1409 14.8346L25.6666 8.16663M7.93331 23.3333H20.0666C22.0268 23.3333 23.0069 23.3333 23.7556 22.9518C24.4142 22.6163 24.9496 22.0808 25.2852 21.4223C25.6666 20.6736 25.6666 19.6935 25.6666 17.7333V10.2666C25.6666 8.30644 25.6666 7.32635 25.2852 6.57766C24.9496 5.91909 24.4142 5.38366 23.7556 5.0481C23.0069 4.66663 22.0268 4.66663 20.0666 4.66663H7.93331C5.97313 4.66663 4.99304 4.66663 4.24435 5.0481C3.58578 5.38366 3.05035 5.91909 2.71479 6.57766C2.33331 7.32635 2.33331 8.30644 2.33331 10.2666V17.7333C2.33331 19.6935 2.33331 20.6736 2.71479 21.4223C3.05035 22.0808 3.58578 22.6163 4.24435 22.9518C4.99304 23.3333 5.97313 23.3333 7.93331 23.3333Z",
    stroke: "#365A6D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.ddb9eee01d3fc50e04739b9c25869050.svg";
export { ForwardRef as ReactComponent };